import React from "react";

import {
  Columns,
  Column,
  Heading,
  MarkdownLite,
  Section,
  Stack,
  Text,
  Box,
} from "@origin-digital/ods-core";

import content from "./content.json";

export const CustomerSection = () => (
  <Section backgroundColor="grey50">
    <Stack alignX="center" space={["small", "xxlarge"]}>
      <Heading variant="h2" align="center">
        {content.heading}
      </Heading>
      <Columns collapseBelow="md">
        {content.sections.map((section, index) => (
          <Column width="flex" key={`customer-section-${index}`}>
            <Box backgroundColor="white" height="full" padding="large">
              <Stack key={`section-${index}`} alignX="left">
                <Stack space="xxsmall">
                  <Text variant="subtitle" align="left">
                    {section.heading}
                  </Text>
                  <Heading variant="h1">{`${section.percentage}%`}</Heading>
                  <Text weight="medium">{`${section.subheading}`}</Text>
                </Stack>
                <Text align="left">
                  <MarkdownLite>{section.text}</MarkdownLite>
                </Text>
              </Stack>
            </Box>
          </Column>
        ))}
      </Columns>
    </Stack>
  </Section>
);
